export const BuildInfo = {timestamp:1779907670000}
